import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import moment from 'moment';
/**
 *
 * @param {Array} one Interval in momentjs
 * @param {Array} two Interval in momentjs
 */

export var overlap = function overlap(one, two) {
  return timeInRange(one[0], two) || timeInRange(one[1], two) || timeInRange(two[0], one) || timeInRange(two[1], one);
};
/**
 * Check if queryed time is inside time range
 * @param {Object} time Momentjs time
 * @param {Array} range
 */

export var timeInRange = function timeInRange(time, range) {
  return moment(time).isBetween(moment(range[0]), moment(range[1]), null, '[]');
};
export var getIntersectionOverlays = function getIntersectionOverlays(time) {
  var overlays = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var MOUSEBUFFERWIDTH = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var dayWidth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var interval1 = [time.clone(), time.clone()];

  if (MOUSEBUFFERWIDTH) {
    interval1[0].subtract(MOUSEBUFFERWIDTH / dayWidth * 24 * 60 * 60 * 1000, 'milliseconds');
    interval1[1].add(MOUSEBUFFERWIDTH / dayWidth * 24 * 60 * 60 * 1000, 'milliseconds');
  }

  return overlays.filter(function (overlay) {
    var interval2 = [moment(overlay.start), moment(overlay.end)];
    return overlap(interval1, interval2);
  });
};
export var getIntersectionLayers = function getIntersectionLayers(time) {
  var layers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var MOUSEBUFFERWIDTH = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var dayWidth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var overlays = layers.reduce(function (acc, l) {
    if (l.period && l.period.length) {
      var cfgs = l.period.map(function (period, index) {
        return {
          key: l.key,
          period: true,
          index: index,
          start: period.start,
          end: period.end
        };
      });
      return [].concat(_toConsumableArray(acc), _toConsumableArray(cfgs));
    } else {
      var cfg = {
        key: l.key,
        period: false,
        start: l.period.start,
        end: l.period.end
      };
      return [].concat(_toConsumableArray(acc), [cfg]);
    }
  }, []);
  var intersection = getIntersectionOverlays(time, overlays, MOUSEBUFFERWIDTH, dayWidth);
  return layers.reduce(function (acc, layer) {
    var intersectionOverlays = intersection.filter(function (i) {
      return i.key === layer.key;
    });

    if (intersectionOverlays && intersectionOverlays.length) {
      if (intersectionOverlays[0].period) {
        var intersectionPeriodsIndexes = intersectionOverlays.map(function (i) {
          return i.index;
        });

        var layerWithPeriods = _objectSpread(_objectSpread({}, layer), {}, {
          period: layer.period.filter(function (p, i) {
            return intersectionPeriodsIndexes.includes(i);
          })
        });

        return [].concat(_toConsumableArray(acc), [layerWithPeriods]);
      } else {
        return [].concat(_toConsumableArray(acc), [layer]);
      }
    } else {
      return acc;
    }
  }, []);
};